import { render, staticRenderFns } from "./privacyHome.vue?vue&type=template&id=369c31a8&scoped=true&"
import script from "./privacyHome.vue?vue&type=script&lang=js&"
export * from "./privacyHome.vue?vue&type=script&lang=js&"
import style0 from "./privacyHome.vue?vue&type=style&index=0&id=369c31a8&scoped=true&lang=css&"
import style1 from "./privacyHome.vue?vue&type=style&index=1&lang=css&"
import style2 from "./privacyHome.vue?vue&type=style&index=2&id=369c31a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369c31a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VImg,VRow,VTextField,VTooltip})
